import Base from '../base';

class AccountRegister extends Base {
	constructor(el) {
		super(el);

		this.gtmData = JSON.parse(this.refs.submit.dataset.gtmPush);

		this.setGtmPushData(this.refs.allowsContact);

		this.on('change');
	}

	onChange(e) {
		const { target } = e;

		if (target === this.refs.allowsContact) {
			this.setGtmPushData(target);
		}
	}

	getGtmPushData(consent) {
		const { gtmData } = this;

		gtmData.consent.mail = consent;

		return JSON.stringify(gtmData);
	}

	setGtmPushData(target) {
		const consent = target.checked ? 'Mail Consent' : 'No Mail Consent';

		this.refs.submit.dataset.gtmPush = this.getGtmPushData(consent);
	}
}

export default AccountRegister;
